// il server segnala che la scommessa è stata data
export const ANSWER_GIVEN = 'ANSWER_GIVEN'
// il server segnala i risultati della scommessa
export const ANSWER_PROCESSED = 'ANSWER_PROCESSED'
// il server segnala che è finita la scommessa
// export const BET_FINISHED = 'bet_finished'
// il server segnala che la scommessa è stata piazzata
export const BET_PLACED = 'BET_PLACED'

export const USER_ANSWERS_RECEIVED = 'USER_ANSWERS_RECEIVED'

export const ANSWER_NOTIFIED = 'ANSWER_NOTIFIED'


export const answerGiven = ({game_id, question_id, user_id, answerMs, answer, old_balance}) => {
    return {type: ANSWER_GIVEN, question_id, game_id, user_id, answerMs, answer, old_balance}
}

export const answerProcessed = (game_id, user_answer, user_id) => {
    return {type: ANSWER_PROCESSED, user_answer, user_id}
}

export const betPlaced = ({game_id, question_id, user_id, bet, balance, old_balance}) => {
    return {type: BET_PLACED, question_id, game_id, user_id, bet, balance, old_balance}
}

export const receiveUserAnswers = (userAnswers, balance, user_id) => {
    return {type: USER_ANSWERS_RECEIVED, userAnswers, balance, user_id}
}

export const onNotified = (user_answer) => {
    return {type: ANSWER_NOTIFIED, user_answer}
}


// WEBPACK FOOTER //
// ./src/reducers/userAnswer/actions.js